export default __webpack_public_path__ + "static/media/help_1_7.79f17ab2.gif";